// extracted by mini-css-extract-plugin
export default {"lapList":"lapList_lapList__0Zi1O","lapList__item":"lapList_lapList__item__64QJV"};